import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Controller } from 'react-hook-form';
import { Button } from 'primereact/button';
import styles from '../stylesheets/MetadataInfo.module.css';
import { CustomButton } from '../../../../components/CustomButton';

const WhatsappProfileEdit = ({
  control,
  errors,
  watch,
  fields,
  append,
  remove,
  profilePicturePreview,
  handleProfilePictureChange,
  handleSubmit,
  onSubmit,
  setIsEditing,
  saving,
  businessCategoryOptions,
}) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* Profile Picture */}
      <div className={`${styles.formGroup} w-full mb-3`}>
        <label>Profile Picture</label>

        {profilePicturePreview && (
          <img src={profilePicturePreview} alt="profile preview" className={styles.profileImage} />
        )}

        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleProfilePictureChange(e.target.files?.[0])}
        />
      </div>

      <div className={styles.formGrid}>
        {/* ABOUT */}
        <div className={styles.formGroup}>
          <label>About</label>

          <Controller
            name="about"
            control={control}
            rules={{
              maxLength: {
                value: 139,
                message: 'About cannot exceed 139 characters',
              },
            }}
            render={({ field }) => <InputTextarea {...field} maxLength={139} rows={3} />}
          />

          <small>{watch('about')?.length || 0}/139</small>

          {errors.about && <small className={styles.error}>{errors.about.message}</small>}
        </div>

        {/* DESCRIPTION */}
        <div className={styles.formGroup}>
          <label>Description</label>

          <Controller
            name="description"
            control={control}
            render={({ field }) => <InputTextarea {...field} rows={4} />}
          />
        </div>

        {/* ADDRESS */}
        <div className={styles.formGroup}>
          <label>Address</label>

          <Controller
            name="address"
            control={control}
            rules={{
              maxLength: {
                value: 256,
                message: 'Address cannot exceed 256 characters',
              },
            }}
            render={({ field }) => <InputText {...field} maxLength={256} />}
          />

          {errors.address && <small className={styles.error}>{errors.address.message}</small>}
        </div>

        {/* EMAIL */}
        <div className={styles.formGroup}>
          <label>Email</label>

          <Controller
            name="email"
            control={control}
            rules={{
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Enter a valid email',
              },
            }}
            render={({ field }) => <InputText {...field} />}
          />

          {errors.email && <small className={styles.error}>{errors.email.message}</small>}
        </div>

        {/* BUSINESS CATEGORY */}
        <div className={styles.formGroup}>
          <label>Business Category</label>

          <Controller
            name="vertical"
            control={control}
            render={({ field }) => (
              <Dropdown
                value={field.value}
                options={businessCategoryOptions}
                onChange={(e) => field.onChange(e.value)}
                placeholder="Select Business Category"
                filter
                className="w-full"
              />
            )}
          />
        </div>

        {/* WEBSITES */}
        <div className={styles.formGroup}>
          <label>Websites</label>

          {fields.map((item, index) => (
            <div key={item.id} style={{ display: 'flex', gap: 8 }}>
              <Controller
                name={`websites.${index}.value`}
                control={control}
                render={({ field }) => <InputText {...field} />}
              />

              {fields.length > 1 && (
                <Button
                  type="button"
                  icon="pi pi-times"
                  className="p-button-danger p-button-text"
                  onClick={() => remove(index)}
                />
              )}
            </div>
          ))}

          {fields.length < 2 && (
            <CustomButton type="button" label="Add Website" onClick={() => append({ value: '' })} />
          )}
        </div>
      </div>

      {/* ACTIONS */}
      <div className={styles.actions}>
        <CustomButton label="Cancel" varient="cancel" onClick={() => setIsEditing(false)} />

        <CustomButton type="submit" label={saving ? 'Saving...' : 'Apply Changes'} />
      </div>
    </form>
  );
};

export default WhatsappProfileEdit;
